/**
 * See the NOTICE file distributed with this work for additional information
 * regarding copyright ownership.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import React from 'react';
import Alert from '@mui/material/Alert';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import Collapse from '@mui/material/Collapse';
import {Box} from "@mui/material";

const styles = {
    root: {
        width: '100%',
        '& > * + *': {
            marginTop: 2,
        },
        marginTop: 3,
        marginBottom: 3,
    },
};

export default function Alerts({messageType, message}) {

    const [open, setOpen] = React.useState(true);

    return (
        <Box sx={styles.root}>
            {/*<Alert severity="info">This is an info alert — check it out!</Alert>*/}
            <Collapse in={open}>
                <Alert
                    severity= {messageType} // "success", "error", "warning", "info"
                    action={
                        <IconButton
                            aria-label="close"
                            color="inherit"
                            size="small"
                            onClick={() => {
                                setOpen(false);
                            }}
                        >
                            <CloseIcon fontSize="inherit"/>
                        </IconButton>
                    }
                >
                    {message}
                </Alert>
            </Collapse>
        </Box>
    );
}
